let hostNameAndPort = `https://touchh.herokuapp.com`

let usersData

let currentUser
let currentlyClickedFullName
let currentlyClikedId
let CurrentlyInViewReciever
let loggedIn = false
let recieverObj

let loginbtn = document.querySelector('.login_btn')
let login_username_field = document.querySelector('.login_usernname_input')
let login_password_field = document.querySelector('.login_password_input')
let login_div = document.querySelector('.login_div')
let allChatContent = document.querySelector('.chatContainer')
let introText = document.querySelector('.intro')
let addUser_btn = document.querySelector('.add_user_image')
let add_user_field = document.querySelector('.search_Add_user')
let chat_history_Container = document.querySelector('.chat_history')
let search_user_btn = document.querySelector('.search_Add_btn')
let allChatHistoryDiv = document.querySelectorAll('.each_chat_history')
let eachHistoryName = document.querySelectorAll('.each_chat_history_name')
let whoYouChattingWith_Image = document.querySelector('.converstaion_with_profile_image')
let whoYouChattingWith_Name = document.querySelector('.converstaion_with_Name')

let eachMessageSend = document.querySelectorAll('.each_messages_send')

let eachMessageRecieve = document.querySelectorAll('.each_messages_recieve')

let typeInMessage_Field = document.querySelector('.type_in_message_input')
let chatBoxContainer = document.querySelector('.chat_messages_itself_cont')

let newMsg = document.querySelectorAll('.newMessage')






import { io } from "socket.io-client";

let socket = io("https://touchh.herokuapp.com")

socket.on('status', function (data) {
  alert(data)
})


socket.on('connect', function () {

  socket.emit('getAllData', 1680)

  socket.on("data", function (data) {
    usersData = data

    loginbtn.addEventListener('click', function (e) {
      e.preventDefault()
      let pendingcurrentUser = usersData.find(function (e, i) {
        return e.username == login_username_field.value
      })
      if (pendingcurrentUser && pendingcurrentUser.password === login_password_field.value) {
        loggedIn = true
        saveStateInfo(login_username_field.value, login_password_field.value)

        currentUser = usersData[usersData.indexOf(pendingcurrentUser)]
        loginFunction.call(currentUser)
        showChatHistoryLoop(currentUser)
        bindEventToEachHistory()

      }
      else {
        login_div.insertAdjacentHTML('beforeend', "<p style='color:red' class='log_in_error_alert'>Invalid Username or Password</p>")
        updateDOM()
        setTimeout(function () {
          document.querySelector('.log_in_error_alert').remove()
        }, 1000)
      }
    })


    let stateLogIn = function (user, pass) {
      let pendingcurrentUser = usersData.find(function (e, i) {
        return e.username == user
      })
      if (pendingcurrentUser && pendingcurrentUser.password === pass) {
        loggedIn = true

        currentUser = usersData[usersData.indexOf(pendingcurrentUser)]
        loginFunction.call(currentUser)
        showChatHistoryLoop(currentUser)
        bindEventToEachHistory()
      }
    }

    if (localStorage.getItem('touchh_state_info')) {
      let stateInfo = JSON.parse(localStorage.getItem('touchh_state_info'))

      stateLogIn(stateInfo.state_User_Name, stateInfo.state_Passowrd)
    }
  })


  let saveStateInfo = function (stateUser, statePass) {
    localStorage.setItem('touchh_state_info', JSON.stringify({
      state_User_Name: stateUser,
      state_Passowrd: statePass
    }))
  }


  document.querySelector('.loadingAnimation').classList.add('hide')
  document.querySelector('.login_div').classList.remove('opa')

  function postAllData() {
    if (!loggedIn) return
    socket.emit("postAllData", usersData, 1680)
  }

  document.querySelector('.menu_btn_cont').addEventListener('click', function () {
    if (!loggedIn) return
    document.querySelector('.settings_div').classList.remove('hide')
    setTimeout(function () {
      document.querySelector('.settings_div').style = 'transform: translateX(0%)'
    }, 30)


    document.querySelector('.chat_box').addEventListener('click', function () {
      document.querySelector('.settings_div').style = 'transform: translateX(110%)'
      setTimeout(function () {
        document.querySelector('.settings_div').classList.add('hide')
      }, 1000)
    })


    document.querySelector('.chat_history').addEventListener('click', function () {
      document.querySelector('.settings_div').style = 'transform: translateX(110%)'
      setTimeout(function () {
        document.querySelector('.settings_div').classList.add('hide')
      }, 1000)
    })
  })

  document.querySelector('.sign_up_link').addEventListener('click', function (e) {
    e.preventDefault()
    document.querySelector('.login_div').classList.add('hide')
    document.querySelector('.signup_div').classList.remove('hide')
  })

  document.querySelector('.log_in_link').addEventListener('click', function (e) {
    e.preventDefault()
    document.querySelector('.login_div').classList.remove('hide')
    document.querySelector('.signup_div').classList.add('hide')
  })

  document.querySelector('.settings').addEventListener('click', function () {
    if (!loggedIn) return
    document.querySelector('.settings_div').classList.remove('hide')
    setTimeout(function () {
      document.querySelector('.settings_div').style = 'transform: translateX(0%)'
    }, 30)


    document.querySelector('.chat_box').addEventListener('click', function () {
      document.querySelector('.settings_div').style = 'transform: translateX(110%)'
      setTimeout(function () {
        document.querySelector('.settings_div').classList.add('hide')
      }, 1000)
    })


    document.querySelector('.chat_history').addEventListener('click', function () {
      document.querySelector('.settings_div').style = 'transform: translateX(110%)'
      setTimeout(function () {
        document.querySelector('.settings_div').classList.add('hide')
      }, 1000)
    })
  })

  document.querySelector('.search').addEventListener('click', function (e) {
    if (!loggedIn) return
    document.querySelector('.search_or_chat').style = 'animation: flash 1s ease-in-out 4;  background-color: #757ffd;'
    setTimeout(function () {
      document.querySelector('.search_or_chat').style = 'animation: none; background-color: none;'
    }, 3000)
  })


  let updateDOM = function () {
    newMsg = document.querySelectorAll('.newMessage')
    loginbtn = document.querySelector('.login_btn')
    login_username_field = document.querySelector('.login_usernname_input')
    login_password_field = document.querySelector('.login_password_input')
    login_div = document.querySelector('.login_div')
    allChatContent = document.querySelector('.chatContainer')
    introText = document.querySelector('.intro')
    whoYouChattingWith_Image = document.querySelector('.converstaion_with_profile_image')
    whoYouChattingWith_Name = document.querySelector('.converstaion_with_Name')
    addUser_btn = document.querySelector('.add_user_image')
    add_user_field = document.querySelector('.search_Add_user')
    chat_history_Container = document.querySelector('.chat_history')
    search_user_btn = document.querySelector('.search_Add_btn')
    allChatHistoryDiv = document.querySelectorAll('.each_chat_history')
    chatBoxContainer = document.querySelector('.chat_messages_itself_cont')
    eachMessageSend = document.querySelectorAll('.each_messages_send')
    eachMessageRecieve = document.querySelectorAll('.each_messages_recieve')
    eachHistoryName = document.querySelectorAll('.each_chat_history_name')
    typeInMessage_Field = document.querySelector('.type_in_message_input')
  }

  let logOut = function () {
    document.querySelector('.logout_btn').addEventListener('click', function () {
      allChatContent.classList.add('hide')
      introText.classList.add('hide')
      document.querySelector('.navContainer').classList.add('hide')
      currentUser.logged_in = false
      document.querySelector('.settings_div').style = 'transform: translateX(110%)'
      setTimeout(function () {
        document.querySelector('.settings_div').classList.add('hide')
      }, 1000)
      login_div.classList.remove('hide')
      addUser_btn.classList.add('hide')
      add_user_field.classList.add('hide')
      search_user_btn.classList.add('hide')
      loggedIn = false


      localStorage.removeItem('touchh_state_info')

      document.querySelector('.profile_div').style = 'transform: translateY(-130%);'
      document.querySelector('.modal_help').classList.add('hide')

      setTimeout(function () {
        document.querySelector('.profile_div').classList.add('hide')
      }, 2000)
      updateDOM()
      postAllData()
    })
  }

  logOut()

  function showChatHistoryLoop(currUser) {
    if (!loggedIn) return
    allChatHistoryDiv.forEach(function (e, i) {
      e.remove()
    })
    currUser.contactList.forEach(function (e, i) {
      let str = `<div class="each_chat_history" data-id="${i}" >
        <div class="pic_box">
          <img src="/user.d03707e7.png" alt="chat_profile_pic" title="search" class="chat_profile_pic" width="50px"
            height="50px" >
        </div>
      
        <div class="details_box">
          <h4 class="each_chat_history_name">${currUser.contactList[i].name}</h4>
      
          <p class="each_chat_history_details">
            Your chat with ${currUser.contactList[i].userName} <span class="newMessage hide">✉️</span>
          </p>
        </div>
      </div > `
      chat_history_Container.insertAdjacentHTML('beforeend', str)
      updateDOM()
      bindEventToEachHistory()
    })
  }


  let searchUser = function () {
    if (!loggedIn) return
    let foundUser = usersData.find(function (e, i) {
      return e.username === add_user_field.value
    })
    if (foundUser && foundUser !== currentUser && !currentUser.contactList.find(function (e) {
      return e.name === foundUser.name
    })) {
      currentUser.contactList.push(
        {
          name: foundUser.name,
          userName: foundUser.username,
          convos: []
        })

      usersData[usersData.indexOf(foundUser)].contactList.push({
        name: currentUser.name,
        userName: currentUser.username,
        convos: []
      })

      showChatHistoryLoop(currentUser)
      add_user_field.value = ''
      updateDOM()
      postAllData()
    }
    else {
      add_user_field.value = ''
      alert('User not found')
    }
  }


  let addUserFunction = function () {
    addUser_btn.addEventListener('click', function () {
      if (!loggedIn) return
      add_user_field.classList.remove('hide')
      search_user_btn.classList.remove('hide')
      search_user_btn.addEventListener('click', function () {
        if (add_user_field.value) {
          searchUser()
        }
      })

    })
  }

  addUserFunction()


  let determineCurrentlyInViewReciever = function () {

    chat_history_Container.addEventListener('click', function (e) {
      if (!loggedIn) return

      updateDOM()

      CurrentlyInViewReciever = eachHistoryName[e.target.closest('.each_chat_history').dataset.id].textContent

      new Promise(function (resolve, reject) {
        reciever = usersData.find(function (e) {
          if (e.name === CurrentlyInViewReciever) resolve(e)
        })
      }).then(function (rec) {
        recieverObj = rec
      })

      renderMessagesinChatBox(usersData[usersData.indexOf(currentUser)].contactList.find(function (e, i) {
        return e.name === currentlyClickedFullName
      }).convos)

      chatBoxContainer.lastElementChild.scrollIntoView({
        behavior: "smooth"
      })

    })
  }


  function renderMessagesinChatBox(contact_list) {
    if (!loggedIn) return
    chatBoxContainer.replaceChildren('')

    contact_list.forEach(function (e, i) {
      if (e.startsWith('-')) {
        chatBoxContainer.insertAdjacentHTML('beforeend', `<div class="each_messages_send">
          ${e.slice(1)}
        </div>`)

      }

      else {
        chatBoxContainer.insertAdjacentHTML('beforeend', `<div class="each_messages_recieve">
          ${e.slice(1)}
        </div>`)

      }
    })

  }


  let loginFunction = function () {

    login_div.classList.add('hide')
    allChatContent.classList.remove('hide')
    introText.classList.remove('hide')
    introText.textContent = `Hello, ${this.name}...`
    this.logged_in = true
    addUser_btn.style = 'animation: flash 1s ease-in-out 4;'
    login_username_field.value = ''
    login_password_field.value = ''
    addUser_btn.classList.remove('hide')
    updateDOM()
    bindEventToEachHistory()
    determineCurrentlyInViewReciever()
    chatBoxContainer.replaceChildren('')
    whoYouChattingWith_Name.textContent = ''
    document.querySelector('.navContainer').classList.remove('hide')

    typeInMessage_Field.classList.add('hide')

    socket.emit("updateId", currentUser.username, socket.id, 1680)
  
    loggedIn = true

  }




  function bindEventToEachHistory() {
    allChatHistoryDiv.forEach(function (e, i) {
      e.addEventListener('click', function (el) {
        updateDOM()

        typeInMessage_Field.classList.remove('hide')

        currentlyClikedId = e.dataset.id
        currentlyClickedFullName = eachHistoryName[e.dataset.id].textContent
        whoYouChattingWith_Name.textContent = currentlyClickedFullName

        newMsg[e.dataset.id].classList.add('hide')

        allChatHistoryDiv.forEach(function (e, i) {
          e.style = 'background-image: linear-gradient(#cccbee, #fae4ea);'
        })
        allChatHistoryDiv.forEach(function (e, i) {
          if (i !== Number(currentlyClikedId)) return
          e.style = ' background-image: linear-gradient(#7a76ec, #f89cb4);'
        })
      })
    })
  }



  function chatFeature(sender, reciever) {
    if (!loggedIn) return
    chatBoxContainer.insertAdjacentHTML('beforeend', `<div class="each_messages_send">
          ${typeInMessage_Field.value}
        </div>`)

    updateDOM()

    eachMessageSend[eachMessageSend.length - 1].scrollIntoView({
      behavior: "smooth"
    })

    let senderObjs = sender

    senderObjs = senderObjs.contactList.find(function (e, i) {
      return e.name == reciever.name
    }).convos.push(`-${typeInMessage_Field.value}`)


    let recieveObj = reciever


    recieveObj = recieveObj.contactList.find(function (e, i) {
      return e.name == sender.name
    }).convos.push(`+${typeInMessage_Field.value}`)


    typeInMessage_Field.value = ''


    updateDOM()
    postAllData()
  }




  document.addEventListener('keydown', function (key) {
    if (!loggedIn) return
    if (key.key == 'Enter') {
      if (typeInMessage_Field.value) {
        socket.emit("sendToReciever", 1680, recieverObj.username, typeInMessage_Field.value, currentUser.username)
        chatFeature(currentUser, recieverObj)
      }
      else {

      }
    }
  })


  //profile modal
  document.querySelector('.profile').addEventListener('click', function (e) {
    if (!loggedIn) return
    setTimeout(function () {
      document.querySelector('.profile_div').classList.remove('hide')
    }, 30)

    setTimeout(function () {
      document.querySelector('.profile_div').style = 'transform: translateY(0%);'
    }, 80)

    document.querySelector('.chatContainer').classList.add('blur')

    document.querySelector('.profile_div').innerHTML = `<img src="/user.d03707e7.png" alt="profile-picture" title="profile_picture" class="profilePicImage">

  <br>
  <p>${currentUser.name} | ${currentUser.gender ? currentUser.gender : 'Not Selected'}</p>
  <p style="font-size: small;">${currentUser.username}</p>

  <hr style="color: white; border-style: solid;opacity: 0.2;">

  <details title="Contact List" class="contactList">
    <summary>Contact List</summary>   
  </details>
`
    updateDOM()

    currentUser.contactList.forEach(function (e) {
      document.querySelector('.contactList').insertAdjacentHTML('beforeend', `<option style='font-size:small; text-align:left'>✔️  &nbsp; ${e.name}</option>`)
    })


    document.querySelector('.chatContainer').addEventListener('click', function () {
      document.querySelector('.profile_div').style = 'transform: translateY(-130%);'

      setTimeout(function () {
        document.querySelector('.profile_div').classList.add('hide')
      }, 30)

      document.querySelector('.chatContainer').classList.remove('blur')
    })
  })


  //profile modal
  document.querySelector('.profile_btn').addEventListener('click', function (e) {
    if (!loggedIn) return
    setTimeout(function () {
      document.querySelector('.profile_div').classList.remove('hide')
    }, 30)

    setTimeout(function () {
      document.querySelector('.profile_div').style = 'transform: translateY(0%);'
    }, 80)

    document.querySelector('.chatContainer').classList.add('blur')

    document.querySelector('.profile_div').innerHTML = `<img src="/user.d03707e7.png" alt="profile-picture" title="profile_picture" class="profilePicImage">

  <br>
  <p>${currentUser.name} | ${currentUser.gender ? currentUser.gender : 'Not Selected'}</p>
  <p style="font-size: small;">${currentUser.username}</p>

  <hr style="color: white; border-style: solid;opacity: 0.2;">

  <details title="Contact List" class="contactList">
    <summary>Contact List</summary>   
  </details>
`
    updateDOM()

    currentUser.contactList.forEach(function (e) {
      document.querySelector('.contactList').insertAdjacentHTML('beforeend', `<option style='font-size:small; text-align:left'>✔️ ${e.name}</option>`)
    })


    document.querySelector('.chatContainer').addEventListener('click', function () {
      document.querySelector('.profile_div').style = 'transform: translateY(-130%);'

      setTimeout(function () {
        document.querySelector('.profile_div').classList.add('hide')
      }, 30)

      document.querySelector('.chatContainer').classList.remove('blur')
    })
  })


  //Delete Account Feauture

  document.querySelector('.delete_account_btn').addEventListener('click', function () {
    if (!loggedIn) return

    document.querySelector('.loadingAnimation').classList.remove('hide')
    setTimeout(function () {
      currentUser.username = `ndnfenfenfvhdebebdkefkfbb`
      currentUser.password = `hdkejfoefnfnfnefndnfenfenf ${undefined}`
      currentUser.status = 'DELETED ACCOUNT'
      document.querySelector('.loadingAnimation').classList.add('hide')
      postAllData()

      allChatContent.classList.add('hide')
      introText.classList.add('hide')
      document.querySelector('.navContainer').classList.add('hide')
      document.querySelector('.settings_div').style = 'transform: translateX(110%)'

      document.querySelector('.modal_help').classList.add('hide')

      setTimeout(function () {
        document.querySelector('.settings_div').classList.add('hide')
      }, 1000)
      login_div.classList.remove('hide')
      addUser_btn.classList.add('hide')
      add_user_field.classList.add('hide')
      search_user_btn.classList.add('hide')
      loggedIn = false
      updateDOM()
    }, 3000)

  })




  //chat feature websocket
  socket.on("recievedMessage", function (key, message, sender) {
    if (key !== 1680) return

    if (sender == recieverObj?.username) {

      chatBoxContainer.insertAdjacentHTML('beforeend', `<div class="each_messages_recieve">
            ${message}
          </div>`)

      chatBoxContainer.lastElementChild.scrollIntoView({
        behavior: "smooth"
      })
      updateDOM()
    }
    else {

      usersData.find(function (e) {
        return e.username == sender
      }).contactList.find(function (ee, i) {
        return ee.userName == currentUser.username
      }).convos.push(`-${message}`)

      currentUser.contactList.find(function (e) {
        return e.userName == sender
      }).convos.push(`+${message}`)

      updateDOM()
      let senderrName = usersData.find(function (e) {
        return e.username === sender
      }).name


      let divIndex

      eachHistoryName.forEach(function (e) {
        if (e.textContent === senderrName) {
          divIndex = e.closest('.each_chat_history').dataset.id
        }
      })

      newMsg[divIndex].classList.remove('hide')

    }
  })


})























